import { type FunctionComponent, useEffect } from 'react';
import { useSelector } from '../../hooks/useSelector';

export type ErrorDetectProps = {
  children?: never;
};

export const ErrorDetect: FunctionComponent<ErrorDetectProps> = () => {
  const fatalError = useSelector((state) => state.error.fatalError);

  useEffect(() => {
    if (fatalError) {
      throw fatalError as Error;
    }
  }, [fatalError]);

  return null;
};
